/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown>, position: NonNullable<unknown>, total: NonNullable<unknown> }} Practice_Drag_OverInputs */



/**
* | output |
* | --- |
* | "{title} is now in position {position} of {total}." |
*
* @param {Practice_Drag_OverInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_drag_over = /** @type {((inputs: Practice_Drag_OverInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Drag_OverInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`${i?.title} staat nu op plaats ${i?.position} van ${i?.total}.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.title} est maintenant en position ${i?.position} sur ${i?.total}.`)
	return /** @type {LocalizedString} */ (`${i?.title} is now in position ${i?.position} of ${i?.total}.`)
});